module.exports = __webpack_public_path__ + "static/media/VU.0335ed85.svg";